import React from 'react'
import { useAppSelector } from '../../../../store/hooks'
import {
  selectCrossClientLandingPollableExecutions,
  selectCrossClientLandingRunningExecutionProgresses,
} from '../../../../store/crossClient/crossClientLanding'
import './CrossClientLandingHistory.scss'
import { CrossClientHistoryElement } from './CrossClientHistoryElement'

export const CrossClientLandingHistory: React.FC = () => {
  const pollableExecutions = useAppSelector(selectCrossClientLandingPollableExecutions)
  const runningExecutionProgresses = useAppSelector(selectCrossClientLandingRunningExecutionProgresses)

  return (
    <div className='d-flex flex-column gap-2 align-items-stretch w-100'>
      {pollableExecutions.map((execution) => {
        const progress = runningExecutionProgresses.find((p) => p.executionId === execution.id)
        return <CrossClientHistoryElement key={execution.id} execution={execution} progress={progress} />
      })}
    </div>
  )
}
